import { DarkOverlayPortal } from "./DarkOverlayPortal"

export const DarkOverlay = props => {
    /**
     * TODO
     * 1. Add onBackdropClick callback
    */

    return /*<DarkOverlayPortal>*/<div className="dark-overlay">{props.children}</div>//</DarkOverlayPortal>
}